import { render, staticRenderFns } from "./refreshPage.vue?vue&type=template&id=4f40cc14&"
import script from "./refreshPage.vue?vue&type=script&lang=js&"
export * from "./refreshPage.vue?vue&type=script&lang=js&"
import style0 from "./refreshPage.vue?vue&type=style&index=0&id=4f40cc14&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports